import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import UsuariosPage from './pages/UsuariosPage';
import TurmasPage from './pages/TurmasPage';
import AnosLetivosPage from './pages/AnosLetivosPage';
import SeriesPage from './pages/SeriesPage';
import AlunosPage from './pages/AlunosPage';
import ResponsaveisPage from './pages/ResponsaveisPage';
import MensalidadesPage from './pages/MensalidadesPage';
import IntegracoesPage from './pages/IntegracoesPage';
import BackupImportPage from './pages/BackupImportPage';
import NotasFiscaisPage from './pages/NotasFiscaisPage';
import RelatoriosPage from './pages/RelatoriosPage';
import { GlobalStyle } from './styles/global';

function App() {
  return (
    <AuthProvider>
      <Router>
        <GlobalStyle />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#333',
              color: '#fff',
            },
          }}
        />
        <Routes>
          {/* Rota pública */}
          <Route path="/login" element={<LoginPage />} />

          {/* Rotas protegidas */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          {/* Rotas futuras para turmas, alunos, etc. */}
          <Route
            path="/turmas"
            element={
              <ProtectedRoute>
                <TurmasPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/alunos"
            element={
              <ProtectedRoute>
                <AlunosPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/responsaveis"
            element={
              <ProtectedRoute>
                <ResponsaveisPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/mensalidades"
            element={
              <ProtectedRoute>
                <MensalidadesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/usuarios"
            element={
              <ProtectedRoute requiredRole="admin">
                <UsuariosPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/anos-letivos"
            element={
              <ProtectedRoute requiredRole="admin">
                <AnosLetivosPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/series"
            element={
              <ProtectedRoute requiredRole="admin">
                <SeriesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/integracoes"
            element={
              <ProtectedRoute requiredRole="admin">
                <IntegracoesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/notas-fiscais"
            element={
              <ProtectedRoute requiredRole="admin">
                <NotasFiscaisPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/importacao-backup"
            element={
              <ProtectedRoute requiredRole="admin">
                <BackupImportPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/relatorios"
            element={
              <ProtectedRoute>
                <RelatoriosPage />
              </ProtectedRoute>
            }
          />

          {/* Rota raiz redireciona para dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Rota 404 */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
